import { render, staticRenderFns } from "./CanvasContextMenu.vue?vue&type=template&id=3a514e94&scoped=true"
import script from "./CanvasContextMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CanvasContextMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CanvasContextMenu.vue?vue&type=style&index=0&id=3a514e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a514e94",
  null
  
)

export default component.exports